import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: theme.spacing(2.5, 3.125),
    color: theme.palette.action.hover,

    '&:hover': {
      backgroundColor: theme.palette.sidebar.background.hover,
    },
  },

  label: {
    height: theme.spacing(3.75),
  },

  icon: {
    color: theme.palette.action.hover,
  },
}));
